/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone', 'underscore'], function(backbone, _) {
    var TemplateModel = backbone.Model.extend(
        {
            defaults: {
                id: null,
                title: null,
                template: null,
                orientation: null,
                shape: null,
                frontImage: null,
                backImage: null
            },

            /**
             * @param {Object} options
             * @returns {TemplateModel}
             */
            fromDTO: function(options) {
                var _this = this;
                _.each(TemplateModel.DTOMap, function(mappedName, attributeName) {
                    if (options[mappedName] !== undefined) {
                        if (mappedName === 'id') {
                            options[mappedName] = parseInt(options[mappedName]);
                        }
                        _this.set(attributeName, options[mappedName]);
                    }
                });
                return this;
            },

            /**
             * @inheritdoc
             */
            parse: function(response, options) {
                this.fromDTO(response);

                return this.attributes;
            }
        },
        {
            DTOMap: {
                id: 'id',
                title: 'title',
                template: 'template',
                orientation: 'orientation',
                shape: 'shape',
                frontImage: 'front_image',
                backImage: 'back_image'
            },
            ORIENTATION_HORIZONTAL: 'landscape',
            ORIENTATION_VERTICAL: 'portrait',
            SHAPE_CIRCLE: 'circle',
            SHAPE_RECTANGLE: 'rectangle'
        }
    );

    return TemplateModel;
});
